import { Controller } from "@hotwired/stimulus"
import consumer from "../channels/consumer"

export default class extends Controller {
  connect() {
    this.subscription = consumer.subscriptions.create("UserExportChannel", {
      received: (data) => {
        if (data.status === "completed") {
          if (data.html && data.dom_id) {
            const element = document.getElementById(data.dom_id)
            if (element) {
              element.outerHTML = data.html
            }
          }
          
          if (data.download_url) {
            window.location.href = data.download_url
          }
        }
      }
    })
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }
}
